import { NextPage } from 'next';
import { Fragment } from 'react';
// -------- custom component -------- // 
import { LocalSEO } from 'components/blocks/portfolio'; 
import NextLink from 'components/reuseable/links/NextLink';
import SEO from 'components/common/SEO';

import * as All from 'data/keywords';
import ProjectDetailsNavigation from 'components/common/ProjectDetailsNavigation';
// -------- custom hook -------- //
import useTooltip from 'hooks/useTooltip';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';

const details = {
  pageName: 'Gold Bear Removals Brighton',
  categories: 'seo, bespoke website design',
  description:
    'Gold Bear Removals is a local removals company based in Brighton, East Sussex. They offer a range of services including house removals, office removals, storage, packing and more. Gold Bear asked us to perform monthly SEO. They rank in the top local results for the most important removals related terms.',
  parentDirectories: 'seo-design-portfolio'
};

const Portfolio = All.LocalSEOArrays[2].keywords;

const contentRowClass = 'row gx-0';
const titleClass = 'display-6 mb-4';

const ProjectDetails: NextPage = () => {
  useTooltip();
  return (
    <Fragment>
      {/* <PageProgress /> */}
      {' '}
      <main className="content-wrapper">
        <SEO
          title={`${Portfolio[0].title} - ${details.pageName}`}
          description={details.description}
          tag={details.categories}
          urlPT={``}
urlENPT={``}
url={`${Portfolio[0].url}/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}`}
          image={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
          // updated=""
          // published=""
          // modified=""
        />
        {/* ========== heading section ========== */}
        <section className="overflow-hidden position-relative lightblue">
          {/* <div className="h-min-100vh h-md-auto color w-100"></div> */}
          <div
            className="container gx-0 text-center wrapper image-wrapper bg-image bg-overlay text-white overflow-hidden d-flex align-items-center"
            style={{ paddingBottom: '20%' }}
          >
            <div className="hero-portfolio position-absolute left-0 top-0">
              <img
                className=""
                src={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg.jpg`}
                // srcSet={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg@2x.jpg 2x`}
                alt={`${Portfolio[1].title}`}
              />
            </div>
            <div className="row mx-auto">
              <div className="col-md-12 mx-auto text-center">
                <div className="post-header mx-auto text-center pt-10">
                  {/* <div className="post-category text-line text-white">Identity</div> */}

                  <h1 className="fs-15 text-uppercase text-dark mb-3">- {Portfolio[0].title} -</h1>
                  <p className="display-4 text-dark text-capitalize">{details.pageName}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ========== details section ========== */}
        <section className="wrapper bg-light wrapper-border">
          <div className="container pt-14 pt-md-16 pb-13 pb-md-15 pe-md-10">
            <div className="row">
              <div className="col-lg-12 offset-lg-0">
                <h2 className={titleClass}>{Portfolio[0].title}</h2>

                <div className={`overflow-hidden ${contentRowClass}`}>
                  <div className="col-lg-8 text-justify order-0 pe-10">
                    {/* <h2 className="display-6 mb-4">{details.pageName}</h2> */}
                    <p>
                      <strong className="caption">{details.description}</strong>
                    </p>{' '}
                    <div className="position-relative">
                      <img
                        width={'100%'}
                        height={'auto'}
                        src={`/img/clients/page-1-google-local.jpg`}
                        alt={`Page 1 Google Local`}
                        style={{ background: 'transparent' }}
                        className="mb-10 mw"
                      />
                    </div>
                    <h3>Local & {Portfolio[1].title}</h3>
                    <p>
                    SEOptimist created a customized digital marketing strategy to help Gold Bear Removals achieve their
                      online goals. They wanted to focus on local SEO services rather than {Portfolio[1].title},
                      targeting customers in the Brighton area.
                    </p>
                    <p>
                      To achieve this, SEOptimist  <NextLink title={All.HomeList[2].title} href="/" /> conducted extensive
                      keyword research to identify the most relevant keywords that Gold Bear Removals' target audience
                      was searching for in their local area. We then implemented a comprehensive local SEO strategy,
                      including optimizing their Google My Business profile, creating local citations, and building
                      high-quality backlinks from local websites.
                    </p>
                    <img
                      width={'100%'}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[2].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[2].title}
                      style={{ background: 'transparent' }}
                      className="mb-10 mw"
                    />
                    <h3>{Portfolio[2].title}</h3>
                    <p>
                      Through our ongoing SEO efforts, we were able to help Gold Bear Removals achieve number 1 results
                      for their desired keywords in Google's local search results. This helped them attract more local
                      customers and increase their revenue.
                    </p>
                    <p>
                      But our digital marketing efforts didn't stop there. We also implemented a content marketing
                      strategy, creating high-quality blog posts and social media content that provided value to Gold
                      Bear Removals' target audience. This helped establish Gold Bear Removals as an authority in their
                      field and generated leads and sales.
                    </p>
                    <img
                      width={'100%'}
                      height={'auto'}
                      src={`/img/clients/national-uk-seo-brighton.jpg`}
                      alt={`National UK SEO Brighton`}
                      style={{ background: 'transparent' }}
                      className="mb-5 mw"
                    />
                    <p>
                      As a {Portfolio[2].title} agency, SEOptimist  <NextLink title={All.HomeList[0].title} href="/" />{' '}
                      understands the unique challenges that businesses in Brighton face when it comes to digital
                      marketing. That's why we offer customized solutions to help businesses achieve their online goals.
                      Contact us today to learn more about our local SEO services and how we can help your business
                      achieve success online.
                    </p>{' '}
                    <NextLink title="Contact" href="/#contact" className="more hover" />
                    <p></p>
                  </div>

                  <div className="col-lg-4 ms-auto order-1 pt-10">
                    <img
                      width={'300'}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[0].title}
                      style={{ background: 'transparent' }}
                      className="mb-10"
                    />{' '}
                    <h5 className="mb-1 text-initial ps-1">
                      <u>Google results</u>
                    </h5>
                    {/* <table className="table table-striped table-hover table-5">
                      <thead>
                        <tr>
                          <th scope="col">Keyword</th>
                          <th scope="col" style={{ width: 71 }}>
                            Local{' '}
                            <figure
                              style={{ float: 'right' }}
                              className="itooltip itooltip-light hover-scale rounded"
                              title={'Google position in local results'}
                            >
                              <i className="uil uil-info-circle"></i>
                            </figure>
                          </th>

                          <th scope="col" style={{ width: 93 }}>
                            Traffic
                            <figure
                              style={{ float: 'right' }}
                              className="itooltip itooltip-light hover-scale rounded"
                              title={'Monthly searches for this term'}
                            >
                              <i className="uil uil-info-circle"></i>
                            </figure>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="border-0">
                          <td>removals Brighton</td>
                          <td className="text-end">3</td>
                          <td className="text-end">960</td>
                        </tr>
                        <tr className="border-0">
                          <td>Brighton removals</td>
                          <td className="text-end">3</td>
                          <td className="text-end">640</td>
                        </tr>
                        <tr className="border-0">
                          <td>removal companies Brighton</td>
                          <td className="text-end">2</td>
                          <td className="text-end">640</td>
                        </tr>
                        <tr className="border-0">
                          <td>Brighton removals company</td>
                          <td className="text-end">3</td>
                          <td className="text-end">280</td>
                        </tr>
                        <tr className="border-0">
                          <td>Brighton removal company</td>
                          <td className="text-end">1</td>
                          <td className="text-end">280</td>
                        </tr>
                        <tr className="border-0">
                          <td>Brighton removals companies</td>
                          <td className="text-end">2</td>
                          <td className="text-end">200</td>
                        </tr>
                        <tr className="border-0">
                          <td>removal company Brighton</td>
                          <td className="text-end">2</td>
                          <td className="text-end">140</td>
                        </tr>
                        <tr className="border-0">
                          <td>Brighton moving</td>
                          <td className="text-end">7</td>
                          <td className="text-end">220</td>
                        </tr>
                        <tr className="border-0">
                          <td>boxes Brighton</td>
                          <td className="text-end">10</td>
                          <td className="text-end">340</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr className="border-0">
                          <td colSpan={2}>
                            <strong>Total</strong>
                          </td>
                          <td className=" text-end">
                            <strong>3,700+</strong>
                          </td>
                        </tr>
                      </tfoot>
                    </table> */}
                    <ul className="list-unstyled">
                      <li>
                        <h5 className="mb-1">Categories</h5>
                        <p>{details.categories}</p>
                      </li>

                      <li>
                        <h5 className="mb-1">Client Name</h5>
                        <p>{details.pageName}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <LocalSEO initialslide={4} />
          </div>
        </section>

        <ProjectDetailsNavigation />
        </main>

        <ContactFooterCombo location="brighton" />
    </Fragment>
  );
};

export default ProjectDetails;
